import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticateGuard, LoginComponent, PasswordLoginComponent } from '@inera/common';
import { LoggedoutComponent } from './components/loggedout/loggedout.component';
import { ErrorViewComponent } from './components/error-view/error-view.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'passwordlogin',
    component: PasswordLoginComponent
  },
  {
    path: 'loggedout',
    component: LoggedoutComponent
  },
  {
    path: '_error',
    component: ErrorViewComponent
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/admin-idp-data-aggregation/admin-siths-eid.module').then(m => m.AdminSithsEidModule),
    canActivate: [AuthenticateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
